const setFeedbackURL = () => {
    document.addEventListener('DOMContentLoaded', function() {
        try {
            const hiddenField = document.querySelector('#feedback-modal input[name="feedback-referrer-url"]');
            if (hiddenField) {
                hiddenField.value = window.location.href;
            }
        } catch (error) {
            console.error('Failed to set feedback URL:', error);
        }
    });
}

export default function init() {
    setFeedbackURL();
}
